import web3 from './web3'
import RE721 from '../../re20-token/build/contracts/ERC721.json'
import RE20ICO from '../../re20-token/build/contracts/CrowdsaleToken.json'

// DEV
// export default {
// 	RE721: web3 != undefined && web3!= null ? new web3.eth.Contract (RE721.abi, '0x4a0fAA624c1F919C935f48aaD4FD4Cd02d92eAef') : null,
// 	RE20ICO: web3 != undefined && web3!= null ? new web3.eth.Contract (RE20ICO.abi, '0xc268322797ff65f8E3B5F7b16f8c23f765C99bE5') : null
// }

// PROD 
export default {
	RE721: web3 != undefined && web3!= null ? new web3.eth.Contract (RE721.abi, '0xa1012a2d68157f0d0c7A9d334C132453dc347Cbb') : null,
	RE20ICO: web3 != undefined && web3!= null ? new web3.eth.Contract (RE20ICO.abi, '0x6723e6342EE8FF181475549a1d7bF96C9b9E48c4') : null
}